import { useState, useEffect, useContext, useRef } from "react";
import {
    Avatar,
    Button,
    Checkbox,
    DatePicker,
    Popover,
    Radio,
    Select,
    notification,
    theme,
} from "antd";
import HTTP from "../../services/httpService";
import logoImage from "../../assets/images/aavgo-logo-dark.png";
import {
    getUserRole,
    disableFutureDates,
    formatDate,
    hotelTypeOptions,
    hotelActiveTypeOptions,
    dateRangePresets,
} from "../../services/util";
import { useNavigate, useParams } from "react-router-dom";
import { SettingContext } from "../../routes";
import {
    ApartmentOutlined,
    ArrowLeftOutlined,
    CheckCircleOutlined,
    ClockCircleOutlined,
    ClusterOutlined,
    KeyOutlined,
    LogoutOutlined,
    MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { LayoutContext } from "../../context/LayoutContext";
import { useAuth0 } from "@auth0/auth0-react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
const { Option } = Select;

const mapSelection = [
    { title: "All Hotels", key: "total_hotel" },
    { title: "Hotel Address", key: "hotel_address" },
    { title: "Total Reservations", key: "checkin_count" },
    { title: "Total CheckIns", key: "total_checkin_new" },
    { title: "Total WalkIns", key: "walkin_count" },
    { title: "Total Scans", key: "scan_count" },
    { title: "Total Keys", key: "keys_count" },
    { title: "Total Cash Collected", key: "cash_collected" },
    { title: "Total Cash", key: "total_cash" },
    { title: "Total Cash Collected Transactions", key: "cash_collected_trans" },
    { title: "Total Cash Dispensed", key: "cash_dispence" },
    { title: "Total Cash Dispensed Transactions", key: "cash_dispenced_trans" },
    { title: "Total Calls", key: "calls_count" },
    { title: "Total Transactions", key: "transaction_count" },
    { title: "Total Housekeeping Tickets", key: "hk_ticket_count" },
    { title: "Total Housekeeping Orders", key: "hk_order_count" },
    { title: "Total Maintenance Tickets", key: "mnt_ticket_count" },
    { title: "Total Dinning Orders", key: "dinning_order_count" },
    { title: "Total Staff Sessions", key: "staff_user_count" },
    { title: "Total Guest Sessions", key: "guest_user_count" },
    { title: "Total IoS Sessions", key: "ios_user_count" },
    { title: "Total Andriod Sessions", key: "android_user_count" },
];

const kioskOptions = [
    { label: "All", value: "1" },
    { label: "Kiosk", value: "2" },
    { label: "Nexus", value: "3" },
];

const hotelTypeFilterOptions = hotelTypeOptions.map((option) => ({
    value: option.key,
    label:
        option.key === "all"
            ? "All Hotels"
            : option.key === "operation"
            ? "Operations Hotels"
            : option.title,
}));

const hotelStatusFilterOptions = hotelActiveTypeOptions.map((option) => ({
    value: option.key,
    label:
        option.key === "all"
            ? "All Hotel Status"
            : option.key === "deactive"
            ? "Deactive Hotels"
            : option.title,
}));

const callCenterFilterOptions = [
    { value: "all", label: "All Call Centers" },
    { value: "1", label: "India Call Center" },
    { value: "2", label: "Philippines Call Center" },
];

const shiftFilterOptions = [
    { value: "all", label: "All Shifts" },
    { value: "am", label: "Morning Shift" },
    { value: "pm", label: "Afternoon Shift" },
    { value: "night", label: "Night Shift" },
];

function renderHeaderFilterOption(option, selectedValue) {
    const optionValue = option?.value ?? option?.data?.value;
    const optionLabel = option?.label ?? option?.data?.label;
    const isSelected = Array.isArray(selectedValue)
        ? selectedValue.includes(optionValue)
        : selectedValue === optionValue;

    if (optionValue === "all") {
        return (
            <div className="dashboard-filter-select-all-option">
                {optionLabel}
            </div>
        );
    }

    return (
        <div className="dashboard-filter-select-option">
            {/* <Checkbox checked={isSelected} onChange={() => {}} /> */}
            <span>{optionLabel}</span>
        </div>
    );
}

function getHeaderMultiSelectValue(values) {
    return values?.length ? values : ["all"];
}

function normalizeHeaderMultiSelectValues(values) {
    if (!Array.isArray(values) || values.length === 0) return [];

    const latestValue = values[values.length - 1];
    if (latestValue === "all") return [];

    return values.filter((value) => value !== "all");
}

const ServiceModelFilterOptions = [
    { value: "all", label: "All Service Models" },
    { value: "1", label: "Shared" },
    { value: "2", label: "Dedicated" },
    { value: "3", label: "Self Service" },
    { value: "4", label: "Operations" },
];
function CustomHeader({
    callDataAPI,
    extraAfter,
    compact = false,
    profileOnly = false,
    hideBack = false,
}) {
    const {
        selectedDates,
        setSelectedDates,
        selectedHotels,
        setSelectedHotels,
        loggedIn,
        singleSelectedHotels,
        setSingleSelectedHotels,
        selectedHotelType,
        setSelectedHotelType,
        selectedHotelActiveType,
        setSelectedHotelActiveType,
        selectedHotelGroup,
        setSelectedHotelGroup,
        selectedCallCenters,
        setSelectedCallCenters,
        selectedShifts,
        selectedServiceModel,
        setSelectedServiceModel,
        kioskSelection,
        setKioskSelection,
        homeActiveTab,
    } = useContext(SettingContext);
    const { logout, isAuthenticated } = useAuth0();
    const tempSelectedHotelType = useRef(selectedHotelType);
    const tempSelectedHotelActiveType = useRef(selectedHotelActiveType);
    const { token } = theme.useToken();

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
            return null;
        }
    }, [loggedIn]);

    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const user = localStorage.getItem(`userFirstname`);
    const hotel_assigned = localStorage.getItem("hotel_assigned");
    let showSelect = true;
    let showSingleSelect = false;
    let showRangePicker = true;
    let showCountsDropdown = false;
    let showHotelTypeSelection = false;
    let showCallTypeSelection = false;
    let showBackButton = true;
    const currentLocation = useLocation().pathname;
    let { hotel_id: urlHotelId } = useParams();
    const userRoleId = localStorage.getItem("userRoleId");
    const userRole = getUserRole(userRoleId);
    if (currentLocation == "/") {
        showBackButton = false;
        showHotelTypeSelection = homeActiveTab != 3 ? true : false;
    }

    if (
        currentLocation.split("/").includes("average_reponse_time") ||
        currentLocation.split("/").includes("average_staff_reponse_time") ||
        currentLocation.split("/").includes("call-answered") ||
        currentLocation.split("/").includes("call-answered-details") ||
        currentLocation.split("/").includes("call-missed") ||
        currentLocation.split("/").includes("call-missed-details") ||
        currentLocation.split("/").includes("total-time-duration") ||
        currentLocation.split("/").includes("reviews-table") ||
        currentLocation.split("/").includes("transaction-duration-table") ||
        currentLocation.split("/").includes("scan-details-table") ||
        currentLocation.split("/").includes("new-call-details") ||
        (currentLocation.split("/").includes("sent_receipt") && !urlHotelId) ||
        (selectedHotelType == "kiosk" &&
            (currentLocation == "/" ||
                currentLocation.split("/").includes("details")))
    ) {
        showCallTypeSelection = true;
    }

    if (
        currentLocation.split("/").includes("category") ||
        currentLocation.split("/").includes("call-time") ||
        currentLocation.split("/").includes("tickets") ||
        currentLocation.split("/").includes("git-dashboard") ||
        currentLocation.split("/").includes("operation-details") ||
        currentLocation.split("/").includes("hotel-counts") ||
        currentLocation.split("/").includes("hubSpot-details-table") ||
        currentLocation.split("/").includes("ticket-form") ||
        currentLocation.split("/").includes("build-upload") ||
        currentLocation.split("/").includes("queue-instances") ||
        currentLocation.split("/").includes("server-instances") ||
        currentLocation.split("/").includes("jira-dashboard") ||
        currentLocation.split("/").includes("Expenditure") ||
        currentLocation.split("/").includes("upcoming-hotels") ||
        currentLocation.split("/").includes("users") ||
        currentLocation.split("/").includes("report-settings") ||
        currentLocation.split("/").includes("alarms") ||
        currentLocation.split("/").includes("kiosk-properties") ||
        currentLocation.split("/").includes("vendors") ||
        currentLocation.split("/").includes("restart-history") ||
        currentLocation.split("/").includes("alarms") ||
        currentLocation.split("/").includes("report-settings") ||
        currentLocation.split("/").includes("team-manangement") ||
        currentLocation.split("/").includes("sprint-analytics") ||
        currentLocation.split("/").includes("rooms") ||
        currentLocation.split("/").includes("business-analytics") ||
        currentLocation.split("/").includes("contacts") ||
        (currentLocation == "/" && homeActiveTab == 3)
    ) {
        showSelect = false;
        showRangePicker = false;
    } else if (
        currentLocation.split("/").includes("calls") ||
        currentLocation.split("/").includes("analytics") ||
        currentLocation.split("/").includes("jira-dashboard") ||
        currentLocation.split("/").includes("tickets-chart") ||
        currentLocation.split("/").includes("hotel-dashboard") ||
        currentLocation.split("/").includes("call-answered-details") ||
        currentLocation.split("/").includes("call-missed-details") ||
        currentLocation.split("/").includes("average_staff_reponse_time") ||
        currentLocation.split("/").includes("id-scanned-audit") ||
        (currentLocation.split("/").includes("shift_notes") && urlHotelId) ||
        (currentLocation.split("/").includes("sent_receipt") && urlHotelId) ||
        (currentLocation.split("/").includes("call-log") && urlHotelId)
    ) {
        showSelect = false;
    } else if (currentLocation.split("/").includes("map")) {
        showCountsDropdown = true;
        showSelect = false;
    } else if (
        currentLocation.split("/").includes("transaction-duration-graph") ||
        currentLocation.split("/").includes("reviews-graph")
    ) {
        showSelect = false;
        showSingleSelect = true;
    } else if (
        currentLocation.split("/").includes("details") ||
        currentLocation.split("/").includes("support-details-table")
    ) {
        showHotelTypeSelection = true;
    } else if (
        currentLocation.split("/").includes("demographic-analytics") ||
        currentLocation.split("/").includes("reservation-analytics") ||
        currentLocation.split("/").includes("maintenance-analytics") ||
        currentLocation.split("/").includes("housekeeping-analytics")
    ) {
        showRangePicker = false;
    } else if (
        currentLocation.split("/").includes("support-analytics") ||
        currentLocation.split("/").includes("hotels") ||
        currentLocation.split("/").includes("transactions")
    ) {
        showSelect = false;
    }
    if (
        currentLocation.split("/").includes("performance-insights") ||
        currentLocation.split("/").includes("key-insights")
    ) {
        showSelect = false;
        showRangePicker = false;
        showHotelTypeSelection = false;
        showCallTypeSelection = false;
    }
    if (userRole == "External Vendor" || userRole === "Customer") {
        showHotelTypeSelection = false;
        showCallTypeSelection = false;
    }
    const showCallCenterShiftSelection = showHotelTypeSelection;
    const navigate = useNavigate();

    const { setCollapsed, isMobile } = useContext(LayoutContext);
    const [hotelListOptions, setHotelListOptions] = useState([]);
    const [hotelGroupOptions, setHotelGroupOptions] = useState([]);
    const [hotelListOptionsSearch, setHotelListOptionsSearch] = useState(true);
    const [mapDataKey, setMapDataKey] = useState("total_hotel");
    const [avatarContentVisible, setAvatarContentVisible] = useState(false);

    const [formData, setFormData] = useState({
        staff_id,
        hotel_type: selectedHotelType,
        hotel_active_type: selectedHotelActiveType,
        group_id: "",
    });
    const {
        status: initailDataStataus,
        data: initialData,
        refetch: getInitialData,
    } = useQuery(
        "initialData",
        async () => {
            return await HTTP("/users/getInitData", formData);
        },
        { enabled: false },
    );

    const {
        status,
        data,
        refetch: getHotels,
    } = useQuery(
        "hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", formData);
        },
        { enabled: false },
    );
    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
            return null;
        }

        getHotels();
        if (currentLocation === "/") {
            getInitialData();
        }
    }, []);

    useEffect(() => {
        const page_reloaded = localStorage.getItem("page_reloaded");
        if (!page_reloaded) {
            localStorage.setItem("page_reloaded", true);
            if (userRole == "External Vendor" && hotel_assigned == "false") {
                notification["warning"]({
                    message: <strong>No data available</strong>,
                    description:
                        "You currently do not have access to any hotel data. Please reach out to your administrator",
                });
            }
        }
    }, []);

    useEffect(() => {
        getHotels();
    }, [formData]);

    useEffect(() => {
        if (tempSelectedHotelType.current != selectedHotelType) {
            setFormData({
                ...formData,
                hotel_type: selectedHotelType,
                hotel_ids: [],
                all_selected: true,
            });
            setSelectedHotels([]);
            tempSelectedHotelType.current = selectedHotelType;
        }
    }, [selectedHotelType]);

    useEffect(() => {
        if (tempSelectedHotelActiveType.current != selectedHotelActiveType) {
            setFormData({
                ...formData,
                hotel_active_type: selectedHotelActiveType,
                hotel_ids: [],
                all_selected: true,
            });
            setSelectedHotels([]);
            tempSelectedHotelActiveType.current = selectedHotelActiveType;
        }
    }, [selectedHotelActiveType]);

    useEffect(() => {
        setFormData((previousFormData) => ({
            ...previousFormData,
            group_id: selectedHotelGroup === "all" ? "" : selectedHotelGroup,
            hotel_ids: [],
            all_selected: true,
        }));
        setSelectedHotels([]);
    }, [selectedHotelGroup]);

    useEffect(() => {
        if (status === "success") {
            setHotelListOptions(data.data);
            setHotelGroupOptions(data.groups);
            setHotelListOptionsSearch(false);
            if (
                currentLocation
                    .split("/")
                    .includes("transaction-duration-graph") ||
                currentLocation.split("/").includes("reviews-graph")
            ) {
                const hotelToBeSelected = data.data.find(
                    (e) => e.hotel_id === parseInt(urlHotelId),
                );
                if (hotelToBeSelected) {
                    setSingleSelectedHotels(
                        `${hotelToBeSelected.hotel_name}#${hotelToBeSelected.hotel_id}`,
                    );
                }
            }
        }
    }, [status, data]);

    function getFilterPayload(overrides = {}) {
        return {
            call_centers: overrides.call_centers ?? selectedCallCenters,
            shift_types: overrides.shift_types ?? selectedShifts,
        };
    }

    function getCurrentHeaderPayload(overrides = {}) {
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        const payload = {
            start_date,
            end_date,
            hotel_ids: selectedHotels,
            ...getFilterPayload(overrides),
        };

        if (currentLocation.split("/").includes("map")) {
            payload.data_for = mapDataKey;
            payload.hotel_ids = [];
            payload.all_selected = true;
            return payload;
        }

        payload.all_selected = payload.hotel_ids.length > 0 ? false : true;
        return payload;
    }

    function handleDateChange(e) {
        let start_date =
            e !== null ? dayjs(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? dayjs(e[1]).startOf("day") : selectedDates[1];

        // set the default value if null
        setSelectedDates([start_date, end_date]);
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        const formData = { start_date, end_date, hotel_ids: [] };
        if (currentLocation.split("/").includes("map")) {
            formData.data_for = mapDataKey;
        } else {
            let hotel_ids;
            if (
                currentLocation
                    .split("/")
                    .includes("transaction-duration-graph") ||
                currentLocation.split("/").includes("reviews-graph")
            ) {
                hotel_ids = [singleSelectedHotels.split("#")[1]];
            } else {
                hotel_ids = selectedHotels;
            }
            formData.hotel_ids = hotel_ids;
        }
        formData.all_selected = formData.hotel_ids.length > 0 ? false : true;
        if (callDataAPI) callDataAPI({ ...formData, ...getFilterPayload() });
    }

    function handleSelectChange(e) {
        const hotel_ids = e;
        setSelectedHotels(e);
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        const formData = {
            start_date,
            end_date,
            hotel_ids,
        };
        formData.all_selected = hotel_ids.length > 0 ? false : true;
        if (callDataAPI) callDataAPI({ ...formData, ...getFilterPayload() });
    }

    function handleCallCenterChange(value) {
        const call_center = value;
        setSelectedCallCenters(call_center);
        if (callDataAPI) {
            callDataAPI(getCurrentHeaderPayload({ call_centers }));
        }
    }

    async function handleLogout() {
        setAvatarContentVisible(false);
        if (isAuthenticated) {
            await logout({
                logoutParams: {
                    silent: true,
                    returnTo: window.location.origin,
                    federated: true,
                },
            });
        }
        const { success } = await HTTP("/users/logout", { staff_id });
        if (success) {
            localStorage.clear();
            window.location.reload();
        }
    }

    function handleMapSelectionChange(e) {
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        setMapDataKey(e.trim());
        const formData = {
            start_date,
            end_date,
            all_selected: true,
            hotel_ids: [],
            data_for: e.trim(),
            ...getFilterPayload(),
        };
        callDataAPI(formData);
    }

    function handleSingleSelectChange(e) {
        let hotel_ids = [];
        if (e) {
            [, hotel_ids] = e.split("#");
        }
        setSingleSelectedHotels(e);
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        const formData = {
            start_date,
            end_date,
            hotel_ids,
            ...getFilterPayload(),
        };
        formData.all_selected = false;
        if (callDataAPI) callDataAPI(formData);
    }

    function handleAvatarVisible(visible) {
        setAvatarContentVisible(visible);
    }

    function handleChangePassword() {
        setAvatarContentVisible(false);
        navigate("/change-password");
    }

    function handleHotelTypeSelection(e) {
        setSelectedHotelType(e);
    }
    function handleHotelActiveTypeSelection(e) {
        setSelectedHotelActiveType(e);
    }

    function handleHotelGroupSelection(e) {
        let group_id = [];
        if (e === "all" || e === undefined || e === null) {
            group_id = ["all"];
        } else {
            group_id = [e];
        }
        setSelectedHotelGroup(group_id);
        if (callDataAPI) {
            callDataAPI(getCurrentHeaderPayload({ group_id }));
        }
    }

    function handleServiceModelSelection(e) {
        let service_model = [];
        if (e === "all" || e === undefined || e === null) {
            service_model = ["all"];
        } else {
            service_model = [e];
        }
        setSelectedServiceModel(service_model);
        if (callDataAPI) {
            callDataAPI(getCurrentHeaderPayload({ service_model }));
        }
    }

    const hotelGroupFilterOptions = [
        { value: "all", label: "All Groups" },
        // hotelGroupOptions?.map((group) => ({
        //     value: Number(group.id),
        //     label: group.group_name,
        // })),
    ];

    const userInitial = user ? user.substring(0, 1).toUpperCase() : "U";
    const avatarBackground = token.colorPrimaryActive || token.colorPrimary;
    const accountMenuContent = (
        <div
            style={{
                width: 220,
                padding: 4,
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "8px 8px 12px",
                    borderBottom: `1px solid ${token.colorBorderSecondary}`,
                    marginBottom: 6,
                }}
            >
                <Avatar
                    size={38}
                    style={{
                        backgroundColor: avatarBackground,
                        color: token.colorWhite,
                        fontWeight: 700,
                    }}
                >
                    {userInitial}
                </Avatar>
                <div style={{ minWidth: 0 }}>
                    <div
                        style={{
                            color: token.colorText,
                            fontSize: 13,
                            fontWeight: 700,
                            lineHeight: 1.25,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {user || "User"}
                    </div>
                    <div
                        style={{
                            color: token.colorTextTertiary,
                            fontSize: 11,
                            lineHeight: 1.4,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {userRole || "Dashboard"}
                    </div>
                </div>
            </div>

            <Button
                type="text"
                block
                icon={<KeyOutlined />}
                onClick={handleChangePassword}
                style={{
                    height: 36,
                    justifyContent: "flex-start",
                    borderRadius: 8,
                    color: token.colorPrimary,
                    fontWeight: 600,
                }}
            >
                Change Password
            </Button>
            <Button
                type="text"
                block
                danger
                icon={<LogoutOutlined />}
                onClick={handleLogout}
                style={{
                    height: 36,
                    justifyContent: "flex-start",
                    borderRadius: 8,
                    fontWeight: 600,
                }}
            >
                Logout
            </Button>
        </div>
    );
    const hasFilterControls =
        showCallTypeSelection ||
        showHotelTypeSelection ||
        showCallCenterShiftSelection ||
        showSelect ||
        showSingleSelect ||
        showCountsDropdown;
    const hasFilterGroup = hasFilterControls;
    const hasActionGroup = Boolean(extraAfter);

    return (
        <div
            className={`dashboard-search-filter dashboard-filter-panel ${
                compact ? "dashboard-filter-panel-compact" : ""
            } ${profileOnly ? "dashboard-filter-panel-profile-only" : ""}`}
        >
            {isMobile && (
                <Button
                    className="dashboard-header-menu-button"
                    type="text"
                    icon={<MenuUnfoldOutlined />}
                    onClick={() => setCollapsed(false)}
                />
            )}

            <div className="dashboard-header-main">
                <div className="dashboard-header-controls">
                    {showRangePicker ? (
                        <div className="dashboard-filter-group dashboard-filter-group-timeframe">
                            <div className="dashboard-filter-group-label">
                                Timeframe
                            </div>
                            <div className="dashboard-filter-group-fields">
                                <RangePicker
                                    allowClear={false}
                                    disabledDate={disableFutureDates}
                                    defaultValue={[
                                        dayjs(selectedDates[0]),
                                        dayjs(selectedDates[1]),
                                    ]}
                                    value={[
                                        dayjs(selectedDates[0]),
                                        dayjs(selectedDates[1]),
                                    ]}
                                    className="dashboard-date-search margin-right-5 select-container"
                                    onChange={handleDateChange}
                                    format="MM/DD/YYYY"
                                    presets={dateRangePresets}
                                />
                            </div>
                        </div>
                    ) : null}

                    {hasFilterGroup ? (
                        <div className="dashboard-filter-group dashboard-filter-group-filters">
                            <div className="dashboard-filter-group-label">
                                {hasFilterControls ? "Filters" : "Actions"}
                            </div>
                            <div className="dashboard-filter-group-fields">
                                {showCallTypeSelection && (
                                    <Radio.Group
                                        options={kioskOptions}
                                        onChange={(e) => {
                                            setKioskSelection(e.target.value);
                                        }}
                                        value={kioskSelection}
                                        optionType="button"
                                        className="select-container kiosk-type-selection"
                                        buttonStyle="solid"
                                    />
                                )}
                                {showHotelTypeSelection ? (
                                    <Select
                                        defaultValue={selectedHotelType}
                                        value={selectedHotelType}
                                        allowClear={false}
                                        className="select-container margin-right-5 width-13"
                                        popupClassName="dashboard-filter-select-dropdown"
                                        prefix={
                                            <ApartmentOutlined className="dashboard-filter-select-prefix" />
                                        }
                                        placeholder="Select Hotel Type"
                                        onChange={handleHotelTypeSelection}
                                        options={hotelTypeFilterOptions}
                                        optionRender={(option) =>
                                            renderHeaderFilterOption(
                                                option,
                                                selectedHotelType,
                                            )
                                        }
                                        menuItemSelectedIcon={null}
                                    />
                                ) : null}
                                {showHotelTypeSelection ? (
                                    <Select
                                        defaultValue={selectedHotelActiveType}
                                        value={selectedHotelActiveType}
                                        allowClear={false}
                                        className="select-container margin-right-5 width-13"
                                        popupClassName="dashboard-filter-select-dropdown"
                                        prefix={
                                            <CheckCircleOutlined className="dashboard-filter-select-prefix" />
                                        }
                                        placeholder="Select Hotel Status"
                                        onChange={
                                            handleHotelActiveTypeSelection
                                        }
                                        options={hotelStatusFilterOptions}
                                        optionRender={(option) =>
                                            renderHeaderFilterOption(
                                                option,
                                                selectedHotelActiveType,
                                            )
                                        }
                                        menuItemSelectedIcon={null}
                                    />
                                ) : null}
                                {showHotelTypeSelection ? (
                                    <Select
                                        value={selectedHotelGroup[0] || "all"}
                                        allowClear={true}
                                        showSearch
                                        className="select-container margin-right-5 width-13"
                                        popupClassName="dashboard-filter-select-dropdown"
                                        prefix={
                                            <ApartmentOutlined className="dashboard-filter-select-prefix" />
                                        }
                                        placeholder="Hotel Group"
                                        onChange={handleHotelGroupSelection}
                                        options={hotelGroupFilterOptions}
                                        optionRender={(option) =>
                                            renderHeaderFilterOption(
                                                option,
                                                selectedHotelGroup,
                                            )
                                        }
                                        menuItemSelectedIcon={null}
                                    />
                                ) : null}
                                {showHotelTypeSelection ? (
                                    <Select
                                        value={selectedServiceModel[0] || "all"}
                                        allowClear={true}
                                        showSearch
                                        className="select-container margin-right-5 width-13"
                                        popupClassName="dashboard-filter-select-dropdown"
                                        prefix={
                                            <ApartmentOutlined className="dashboard-filter-select-prefix" />
                                        }
                                        placeholder="Service Model"
                                        onChange={handleServiceModelSelection}
                                        options={ServiceModelFilterOptions}
                                        optionRender={(option) =>
                                            renderHeaderFilterOption(
                                                option,
                                                selectedServiceModel,
                                            )
                                        }
                                        menuItemSelectedIcon={null}
                                    />
                                ) : null}
                                {showCallCenterShiftSelection ? (
                                    <Select
                                        // mode="multiple"
                                        value={selectedCallCenters}
                                        allowClear={true}
                                        showSearch={false}
                                        className="select-container margin-right-5 width-13 dashboard-filter-multi-select"
                                        popupClassName="dashboard-filter-select-dropdown"
                                        prefix={
                                            <ClusterOutlined className="dashboard-filter-select-prefix" />
                                        }
                                        placeholder="All Call Centers"
                                        options={callCenterFilterOptions}
                                        optionRender={(option) =>
                                            renderHeaderFilterOption(
                                                option,
                                                selectedCallCenters,
                                            )
                                        }
                                        onChange={handleCallCenterChange}
                                        menuItemSelectedIcon={null}
                                        maxTagCount={1}
                                    />
                                ) : null}
                                {/* {showCallCenterShiftSelection ? (
                                    <Select
                                        mode="multiple"
                                        value={getHeaderMultiSelectValue(
                                            selectedShifts,
                                        )}
                                        allowClear={false}
                                        showSearch={false}
                                        className="select-container margin-right-5 width-13 dashboard-filter-multi-select"
                                        popupClassName="dashboard-filter-select-dropdown"
                                        prefix={
                                            <ClockCircleOutlined className="dashboard-filter-select-prefix" />
                                        }
                                        placeholder="All Shifts"
                                        options={shiftFilterOptions}
                                        optionRender={(option) =>
                                            renderHeaderFilterOption(
                                                option,
                                                selectedShifts,
                                            )
                                        }
                                        onChange={handleShiftChange}
                                        menuItemSelectedIcon={null}
                                        maxTagCount={1}
                                    />
                                ) : null} */}
                                {showSelect ? (
                                    <Select
                                        defaultValue={selectedHotels}
                                        value={selectedHotels}
                                        showSearch
                                        mode="multiple"
                                        allowClear
                                        className="select-container margin-right-5"
                                        placeholder="Hotel Name"
                                        filterOption={(input, option) =>
                                            option.children
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        onChange={handleSelectChange}
                                        loading={hotelListOptionsSearch}
                                    >
                                        {hotelListOptions.map((option) => (
                                            <Option
                                                key={option.hotel_id}
                                                value={option.hotel_id}
                                            >
                                                {`${option.hotel_id} - ${option.hotel_name} - ${option.city}`}
                                            </Option>
                                        ))}
                                    </Select>
                                ) : null}

                                {showSingleSelect ? (
                                    <Select
                                        defaultValue={singleSelectedHotels}
                                        showSearch
                                        className="select-container"
                                        placeholder="Hotel Name"
                                        allowClear
                                        onChange={handleSingleSelectChange}
                                        loading={hotelListOptionsSearch}
                                    >
                                        {hotelListOptions.map((option) => (
                                            <Option
                                                key={`${option.hotel_name}#${option.hotel_id}`}
                                            >
                                                {`${option.hotel_id} - ${option.hotel_name}`}
                                            </Option>
                                        ))}
                                    </Select>
                                ) : null}

                                {showCountsDropdown ? (
                                    <Select
                                        defaultValue={"total_hotel"}
                                        showSearch
                                        allowClear={false}
                                        className="select-container margin-right-5"
                                        placeholder="Select field"
                                        onChange={handleMapSelectionChange}
                                        loading={hotelListOptionsSearch}
                                    >
                                        {mapSelection.map((option) => (
                                            <Option key={`${option.key}`}>
                                                {option.title}
                                            </Option>
                                        ))}
                                    </Select>
                                ) : null}
                            </div>
                        </div>
                    ) : null}

                    {hasActionGroup ? (
                        <div className="dashboard-filter-group dashboard-filter-group-actions">
                            <div className="dashboard-filter-group-label">
                                Actions
                            </div>
                            <div className="dashboard-filter-group-fields dashboard-filter-actions-fields">
                                <div className="dashboard-header-extra">
                                    {extraAfter}
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className="icon-container">
                    {showBackButton && !hideBack ? (
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <ArrowLeftOutlined /> Back
                        </Button>
                    ) : null}
                    <Popover
                        placement="bottomRight"
                        content={accountMenuContent}
                        open={avatarContentVisible}
                        onOpenChange={handleAvatarVisible}
                        trigger="click"
                    >
                        <Avatar
                            style={{
                                backgroundColor: avatarBackground,
                                verticalAlign: "middle",
                                cursor: "pointer",
                                boxShadow: `0 0 0 3px ${token.colorPrimaryBg}`,
                            }}
                            size="default"
                        >
                            {userInitial}
                        </Avatar>
                    </Popover>
                </div>
            </div>
        </div>
    );
}

export default CustomHeader;
